'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const Relay = require('react-relay/classic');
const get = require('lodash.get');
const { Provider } = require('react-redux');
const { combineReducers, createStore, applyMiddleware } = require('redux');
const { contactModal } = require('dibs-buyer-layout/src/entries/index');
const { track } = require('dibs-buyer-layout/src/utils/chat');

const modalContainer = document.createElement('div');
const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const { getEnvironment } = require('../../../global/relayEnvironmnentProvider.es').default;

module.exports = options => {
    contactModal().then(mod => {
        const { NetPriceModal, ModalWrapper, reducers } = mod;
        const { item, itemPk, currency, linkLocation } = options;
        const { fields, modalWrapper, tracking, validation } = reducers;

        const store = createStore(
            combineReducers({ fields, modalWrapper, tracking, validation }),
            applyMiddleware(require('redux-thunk').default)
        );

        // Check if backbone model passed
        const sellerId = item && item.get ? item.get('seller.id') : get(item, 'seller.serviceId');
        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

        const queryConfig = {
            queries: {
                viewer: (Component, params) => Relay.QL`
                    query {
                        viewer {
                            ${Component.getFragment('viewer', params)}
                        }
                    }
                `,
            },
            name: 'NetPriceModalRoute',
            params: {
                userId,
                userIds: [userId],
                sellerId,
                itemId: itemPk,
                itemIds: [itemPk],
                shouldFetchItem: !!itemPk,
                shouldFetchUser: !!userId,
                shouldFetchBuyerItemConv: !!itemPk && !!userId,
            },
        };

        ReactDOM.render(
            <Provider store={store}>
                <Relay.Renderer
                    Container={NetPriceModal}
                    environment={getEnvironment()}
                    queryConfig={queryConfig}
                    // eslint-disable-next-line react/prop-types
                    render={({ done, error, props }) => {
                        if (error) {
                            return <ModalWrapper openOnRender isError />;
                        } else if (done && props) {
                            const netPriceProps = Object.assign({}, props, {
                                chatTracking: track,
                                currency,
                                linkLocation,
                            });
                            return <NetPriceModal {...netPriceProps} />;
                        } else {
                            return <ModalWrapper openOnRender isLoading />;
                        }
                    }}
                />
            </Provider>,
            modalContainer
        );
    });
};



// WEBPACK FOOTER //
// ./assets/js/contact/netPrice/helpers/netPriceLauncher.jsx